(() => {
  'use strict';
  if (window.dtNumberedPacksLoaded) return;
  const configNode = document.getElementById('dt-numbered-pack-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  window.dtNumberedPacksLoaded = true;
  const parents = [
    [10612492763483, 53650514542939],
    [10840634556763, 54519922098523],
    [10840638619995, 54519961059675],
    [10840640848219, 54519967285595],
    [10840641962331, 54519970005339],
    [10840642552155, 54519971578203],
    [10840642978139, 54519973675355],
    [10840644551003, 54519986946395],
    [10840645140827, 54519991107931],
    [10840646713691, 54519995203931]
  ];
  const root = window.Shopify?.routes?.root || '/';
  const originalFetch = window.fetch.bind(window);
  let pending = Promise.resolve();
  const failure = message => new Response(JSON.stringify({status:422, message, description:message}), {status:422, headers:{'Content-Type':'application/json'}});
  const request = async (path, data) => {
    const response = await originalFetch(root + path, data === undefined ? {cache:'no-store', headers:{Accept:'application/json'}} : {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(data)});
    if (!response.ok) throw new Error(config.error);
    return response;
  };
  const readCart = async () => (await request('cart.js')).json();
  const nextSlot = cart => {
    const used = new Set(cart.items.map(item => Number(item.variant_id)));
    return parents.findIndex(parent => !used.has(parent[1]));
  };
  let displayedSlot = null;
  let refreshVersion = 0;
  const renderSlot = () => {
    if (displayedSlot === null) return;
    const pattern = /^(Crea tu pack personalizado)\s+\d+$/i;
    document.querySelectorAll('#bundlesuiteContainer .template-top-data-header-title h2, sticky-add-to-cart .dt-sticky-title-first').forEach(node => {
      const title = node.textContent.trim().replace(pattern, '$1 ' + displayedSlot);
      if (node.textContent !== title) node.textContent = title;
    });
    document.querySelectorAll('#bundlesuiteContainer img[alt]').forEach(node => {
      const alt = node.alt.replace(pattern, '$1 ' + displayedSlot);
      if (node.alt !== alt) node.alt = alt;
    });
  };
  const syncSlot = cart => {
    const slot = nextSlot(cart);
    displayedSlot = slot < 0 ? parents.length : slot + 1;
    renderSlot();
  };
  const refreshSlot = async () => {
    const version = ++refreshVersion;
    try {
      const cart = await readCart();
      if (version === refreshVersion) syncSlot(cart);
    } catch (error) {}
  };
  const startTitleSync = () => {
    new MutationObserver(renderSlot).observe(document.body, {childList:true, subtree:true, characterData:true});
    refreshSlot();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startTitleSync, {once:true});
  else startTitleSync();
  window.addEventListener('pageshow', refreshSlot);
  window.addEventListener('focus', refreshSlot);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshSlot();
  });
  const ownLines = (cart, marker) => cart.items.filter(item => item.properties?.__dt_numbered_build === marker);
  const cleanup = async marker => {
    const lines = ownLines(await readCart(), marker);
    if (lines.length) await request('cart/update.js', {updates:Object.fromEntries(lines.map(item => [item.key, 0]))});
    if (ownLines(await readCart(), marker).length) throw new Error(config.cleanup_error);
  };
  async function addNumbered(input, init, payload) {
    const marker = crypto.randomUUID();
    let attempted = false;
    try {
      const cart = await readCart();
      const used = new Set(cart.items.map(item => Number(item.variant_id)));
      const expected = [];
      const items = [];
      for (const item of payload.items) {
        if (Number(item.id) !== parents[0][1] || !item.properties?.__byob) {items.push(item); continue;}
        const count = Number(item.quantity ?? 1);
        if (!Number.isInteger(count) || count < 1 || count > parents.length) return failure(config.limit);
        const bundle = JSON.parse(item.properties.__byob);
        if (bundle.v !== 2 || !bundle.s || !Array.isArray(bundle.c) || !bundle.c.length) return failure(config.error);
        const total = Number(item.properties.__totalByobPresentmentCurrency === cart.currency ? item.properties.__totalByobPresentment : item.properties.__totalByob);
        if (!Number.isFinite(total) || total <= 0) return failure(config.error);
        for (let unit = 0; unit < count; unit++) {
          const slot = parents.findIndex(parent => !used.has(parent[1]));
          if (slot < 0) return failure(config.limit);
          const [productId, variantId] = parents[slot];
          used.add(variantId);
          const build = structuredClone(bundle);
          build.s._BS_productId = String(productId);
          if (count > 1) build.s._BS_bundleId = crypto.randomUUID();
          const properties = {...item.properties, __byob:JSON.stringify(build), __dt_numbered_build:marker, __dt_numbered_slot:String(slot + 1)};
          items.push({...item, id:variantId, quantity:1, properties});
          const verifyPrice = item.properties.__totalByobPresentmentCurrency === cart.currency || cart.currency === 'EUR';
          expected.push({variantId, components:build.c, total:verifyPrice ? Math.round(total * 100) : null});
        }
      }
      const options = {...init, body:JSON.stringify({...payload, items})};
      attempted = true;
      let response;
      try {response = await originalFetch(input, options);} catch (error) {}
      const checked = await readCart();
      const lines = ownLines(checked, marker);
      let complete = lines.length === expected.length && expected.every(item => lines.some(line => Number(line.variant_id) === item.variantId && line.quantity === 1 && line.final_line_price > 0 && (item.total === null || line.original_line_price === item.total)));
      if (complete) {
        const html = await (await request('?section_id=helper-cart')).text();
        const rendered = new DOMParser().parseFromString(html, 'text/html');
        complete = expected.every(item => {
          const line = lines.find(line => Number(line.variant_id) === item.variantId);
          const row = [...rendered.querySelectorAll('[data-js-cart-item]')].find(row => row.dataset.id === line.key);
          const components = [...(row?.querySelectorAll('[data-dt-component-variant]') || [])];
          const quantities = new Map();
          for (const entry of item.components) quantities.set(Number(entry[0]), (quantities.get(Number(entry[0])) || 0) + Number(entry[1]));
          return row?.dataset.dtIsBundle === 'true' && components.length === quantities.size && [...quantities].every(([id, quantity]) => components.some(component => Number(component.dataset.dtComponentVariant) === id && Number(component.dataset.dtComponentQuantity) === quantity));
        });
      }
      if (!complete) {
        await cleanup(marker);
        return failure(config.error);
      }
      ++refreshVersion;
      syncSlot(checked);
      return response?.ok ? response : new Response(JSON.stringify({items:lines}), {status:200, headers:{'Content-Type':'application/json'}});
    } catch (error) {
      if (attempted) {
        try {await cleanup(marker);} catch (cleanupError) {return failure(config.cleanup_error);}
      }
      return failure(config.error);
    }
  }
  window.fetch = function (input, init) {
    let url;
    try {url = new URL(input instanceof Request ? input.url : input, location.href);} catch (error) {return originalFetch(input, init);}
    const method = init?.method || (input instanceof Request ? input.method : 'GET');
    const isCartWrite = url.origin === location.origin && /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname) && method.toUpperCase() === 'POST';
    const passthrough = () => {
      const result = originalFetch(input, init);
      if (isCartWrite) result.then(response => { if (response.ok) refreshSlot(); }, () => {});
      return result;
    };
    if (url.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname) || method.toUpperCase() !== 'POST' || typeof init?.body !== 'string') return passthrough();
    let payload;
    try {payload = JSON.parse(init.body);} catch (error) {return passthrough();}
    if (!Array.isArray(payload.items) || !payload.items.some(item => Number(item.id) === parents[0][1] && item.properties?.__byob)) return passthrough();
    const task = () => navigator.locks?.request ? navigator.locks.request('dt-numbered-personalized-packs', () => addNumbered(input, init, payload)) : addNumbered(input, init, payload);
    const result = pending.then(task, task);
    pending = result.catch(() => {});
    return result;
  };
})();
